var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusLate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_85287",
    d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M12,22.1C6.4,22.1,1.9,17.6,1.9,12 S6.4,1.9,12,1.9c5.6,0,10.1,4.5,10.1,10.1l0,0C22.1,17.6,17.6,22.1,12,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85288_00000085941367865810878890000011962417541372770190_",
    d: "M12,5.8c-0.5,0-0.9,0.4-0.9,0.9v6 c0,0.5,0.5,0.9,1,0.9c0.5,0,0.9-0.4,0.9-0.9v-6C12.9,6.2,12.5,5.8,12,5.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_541",
    cx: 12,
    cy: 16.1,
    r: 1.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLate);
export default __webpack_public_path__ + "static/media/status_late.98f0e950e5e51b55da59ee48b3d176d6.svg";
export { ForwardRef as ReactComponent };